/**
 * @enum LvfVehicleNationalCategory
 *  * @classdesc Represents the supported equipment national category source (vehicle legacy naming).
 */
export enum LvfVehicleNationalCategory {

  VP = 1,
  CTTE = 2,
  CAM = 3,
  TRR = 4,
  SREM = 5,
  REM = 6,
  QM = 7
}
